export const PLAN_INACTIVE = 'PLAN_INACTIVE';
export const FEATURE_NOT_ENABLED = 'FEATURE_NOT_ENABLED';
export const BILLING_FEATURE_NOT_FOUND = 'BILLING_FEATURE_NOT_FOUND';
export const BILLING_FEATURE_PROTECTED = 'BILLING_FEATURE_PROTECTED';

export const billingErrorCodes = [
  PLAN_INACTIVE,
  FEATURE_NOT_ENABLED,
  BILLING_FEATURE_NOT_FOUND,
  BILLING_FEATURE_PROTECTED,
] as const;

export type BillingErrorCode = (typeof billingErrorCodes)[number];
